import React, { useCallback } from "react";
import FilterGruposMonitoria from "../../components/FilterGruposMonitoria";
import BaseLayout from "../../components/Layout";
import { actionGetLojaById } from "../../features/dados-loja/loja-by-id/slices";
import { actionGetPontosMonitoriaByLoja } from "../../features/monitoramento/lista-pontos/slices";
import conectSocket from "../../helpers/connect-socket";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import "./styles.scss";

const PagePlantaBaixa = () => {
  const initialState = {
    filter: null,
    listPontosDeMonitoria: [],
  } as any;

  const dispatch = useAppDispatch();
  const [state, setState] = React.useState(initialState);
  const getGrupoSelected = (filter) => setState({ ...state, filter });

  const {
    getLojaById,
    pontosMonitoriaByLoja,
    getLojas: { lojaSelected },
  } = useAppSelector((state) => state);

  const lojas = useAppSelector((state) => state.getLojas.lojas);

  const createList = useCallback(
    (data) => {
      if (!data) return;

      const filtered = !state.filter
        ? data
        : data.filter(({ id }) => id === state.filter);

      const listPontosDeMonitoria = filtered
        .map((item) => [...item.listaMonA, ...item.listaMonD])
        .flat()
        .filter((item) => item.alertaAtivo && item);

      setState((prev) => ({
        ...prev,
        listPontosDeMonitoria,
      }));
    },
    [state.filter],
  );

  React.useEffect(() => {
    if (lojaSelected) {
      dispatch(actionGetLojaById());
      dispatch(actionGetPontosMonitoriaByLoja(lojaSelected));
    }
  }, [dispatch, lojaSelected]);

  React.useEffect(() => {
    if (pontosMonitoriaByLoja.data?.grupoMonitor) {
      createList(pontosMonitoriaByLoja.data.grupoMonitor);
    }
  }, [pontosMonitoriaByLoja.data, createList]);

  React.useEffect(() => {
    if (!lojaSelected) return;

    console.log("Iniciando Socket Planta Baixa...");

    const connection = conectSocket({
      url: `hubLoja?idLoja=${lojaSelected}`,
      hub: "PostLojaHub",
      cb: (responseSocket) => createList(responseSocket.grupoMonitor),
    });

    return () => {
      if (connection) {
        console.log("Fechando Socket Planta Baixa...");
        connection.stop();
      }
    };
  }, [lojaSelected, createList]);

  if (!lojaSelected) {
    return (
      <BaseLayout>
        <div className="container">
          <strong>Para iniciar selecione uma loja</strong>
        </div>
      </BaseLayout>
    );
  }

  if (getLojaById.status === "loading") {
    return (
      <BaseLayout>
        <div className="container">
          <strong>carregando...</strong>
        </div>
      </BaseLayout>
    );
  }

  if (getLojaById.status === "success" && !getLojaById.data) {
    return (
      <BaseLayout>
        <div className="container">
          <strong>Não existe planta cadastrada para essa loja</strong>
        </div>
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <div className="container">
        <div className="row">
          <>
            {lojas.length > 0 && (
              <div className="container" style={{ marginBottom: "1.5rem" }}>
                <strong style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                  {lojas.find((loja) => loja.id === Number(lojaSelected))?.nome}
                </strong>
              </div>
            )}
          </>
          <div className="col-4 mb-20">
            <FilterGruposMonitoria cb={getGrupoSelected} />
          </div>
        </div>
        <div
          style={{
            backgroundImage: `url(${getLojaById.data.arquivoPlanta})`,
          }}
          className="planta"
        >
          {state.listPontosDeMonitoria.map((item) => (
            <div
              style={{ left: `${item.coordX}px`, top: `${item.coordY}px` }}
              className={`planta__alert ${
                item.statusOk ? "success" : "danger"
              }`}
            >
              <p>
                {item.equipamento.nome} {item.sequenciaItem}
              </p>
            </div>
          ))}
        </div>
      </div>
    </BaseLayout>
  );
};

export default PagePlantaBaixa;
